import $ from 'jquery';

/* Loadmore
********************************************/

$(document).ready(function() {
			var urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('page')) {

				var page = parseInt(urlParams.get('page'));

				if (typeof page === 'number' && page > 1 ) {

					var canBeLoaded = false; // this param allows to initiate the AJAX call only if necessary

					var data = {
						action: 'loadmore_paged',
						query: EAPLUS_VARS.posts,
						page: page,
						post_type: EAPLUS_VARS.post_type,
					};

					const button = $('.btn-loadmore');

					$.ajax({
						url: EAPLUS_VARS.ajax_url,
						data: data,
						type: 'POST',
						beforeSend: function(xhr) {
							canBeLoaded = false;
							button.text(EAPLUS_VARS.loading_str);
						},
						success: function(data) {
							if (data) {
								$('.items').html(data);
								EAPLUS_VARS.current_page = page;
								if (EAPLUS_VARS.current_page == EAPLUS_VARS.max_page) {
									$('.loadmore-wrapper').remove();
									canBeLoaded = false;
								} else {
									button.text(EAPLUS_VARS.loadmore_str);
									canBeLoaded = true;
								}
								if (history.replaceState) {
									var base_url = location.protocol + '//' + location.host + location.pathname;
									var new_url = base_url + "?page=" + page;
									history.replaceState('', '', new_url);
								}
								var target = $('#items');
								var headerHeight = $('.header').outerHeight();
								var targetBottom = target.offset().top + target.outerHeight();
								var offset = $('#items').children('.col').last().height();
								$('html, body').animate({
									scrollTop: targetBottom - $(window).height() + offset + headerHeight
								}, 1000);
							}
						}
					});
				}

			}
});
if ($('.btn-loadmore').length) {
			if (EAPLUS_VARS.current_page == EAPLUS_VARS.max_page) {
				$('.loadmore-wrapper').remove();
			}
			$('.btn-loadmore').on('click', function(event) {

				event.preventDefault();

				var canBeLoaded = false, // this param allows to initiate the AJAX call only if necessary
					bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts

				var data = {
					action: 'loadmore',
					query: EAPLUS_VARS.posts,
					page: EAPLUS_VARS.current_page,
					post_type: EAPLUS_VARS.post_type
				};

				const button = $(this);

				//$(this).hide();

				$.ajax({
					url: EAPLUS_VARS.ajax_url,
					data: data,
					type: 'POST',
					beforeSend: function(xhr) {
						canBeLoaded = false;
						button.text(EAPLUS_VARS.loading_str);
					}
				}).done(function(data) {
					if (data) {

						$('.items').append(data);
						EAPLUS_VARS.current_page++;

						if (EAPLUS_VARS.current_page == EAPLUS_VARS.max_page) {
							$('.loadmore-wrapper').remove();
							canBeLoaded = false;
						} else {
							canBeLoaded = true;
						}
						if (history.replaceState) {
							var base_url = location.protocol + '//' + location.host + location.pathname;
							var new_url = base_url + "?page=" + (EAPLUS_VARS.current_page);
							history.replaceState('', '', new_url);
						}
					} else {
						$('.loadmore-wrapper').remove();
						canBeLoaded = false;
					}
				}).always(function() {
					//button.text(convertiv_loadmore_params.loadmore_str);
				});

				//canBeLoaded = true;

				$(window).scroll(function() {

					var data = {
						action: 'loadmore',
						query: EAPLUS_VARS.posts,
						page: EAPLUS_VARS.current_page,
						post_type: EAPLUS_VARS.post_type
					};

					if ($(document).scrollTop() > ($(document).height() - bottomOffset) && canBeLoaded == true) {

						const button = $('.btn-loadmore');

						$.ajax({
							url: EAPLUS_VARS.ajax_url,
							data: data,
							type: 'POST',
							beforeSend: function(xhr) {
								canBeLoaded = false;
								button.text(EAPLUS_VARS.loading_str);
							},
							success: function(data) {
								if (data) {
									$('.items').append(data);
									//canBeLoaded = true;
									EAPLUS_VARS.current_page++;
									if (EAPLUS_VARS.current_page == EAPLUS_VARS.max_page) {
										$('.loadmore-wrapper').remove();
										canBeLoaded = false;
									} else {
										canBeLoaded = true;
									}
									if (history.replaceState) {
										var base_url = location.protocol + '//' + location.host + location.pathname;
										var new_url = base_url + "?page=" + (EAPLUS_VARS.current_page);
										history.replaceState('', '', new_url);
									}
								}
							}
						});
					}
				});

			});
}
